import React from 'react';
import { Dropdown, List } from 'tea-component';
import useIntls from '@opm/hooks/useIntls';

interface IDropdownOption {
  key: string;
  labelId: string;
}

type TDropdownPlacement =
  | 'top'
  | 'bottom'
  | 'top-start'
  | 'top-end'
  | 'bottom-start'
  | 'bottom-end';
interface ISelectDropdownProps {
  value: string;
  onChange: (value: string) => void;
  options: IDropdownOption[];
  placement?: TDropdownPlacement;
  style?: React.CSSProperties;
  [key: string]: any;
  btnPrefixText?: string;
  showBtnPrefixText?: boolean;
  customButton?: React.ReactNode;
}

const SelectDropdown = (props: ISelectDropdownProps) => {
  const { value, onChange, options, placement = 'bottom', style = {}, btnPrefixText = 'Sort By', showBtnPrefixText = true, customButton, ...dropdownProps } = props;
  const { intl } = useIntls();

  const menu = () => (
    <List type="option">
      {options.map(({ key, labelId }) => (
        <List.Item
          key={key}
          onClick={() => onChange(key)}
          selected={value === key}
        >
          {intl({ id: labelId })}
        </List.Item>
      ))}
    </List>
  );

  const currentLabel =
    options.find(opt => opt.key === value)?.labelId || options[0]?.labelId;

  return (
    <Dropdown
      style={{ ...style }}
      button={customButton ?? (
        <div className="select-button">
          {
            showBtnPrefixText && (
              <span className="select-button-text">
                {intl(btnPrefixText)}
              </span>
            )
          }
          <span className="dbo-select-flex">{intl(currentLabel)}</span>
        </div>
      )}
      appearance="link"
      placement={placement}
      {...dropdownProps}
    >
      {menu}
    </Dropdown>
  );
};

export default SelectDropdown;